import React, { useEffect, useState } from "react";
import axios from "axios";
import { connection } from "./signalr";
import ChatList from "./ChatList";
import ChatWindow from "./ChatWindow";
import "./styles.css";
import { useLocation } from "react-router-dom";

function ChatInit() {
 const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  var location = useLocation();
  var { opponentId,opponentName } = location.state || {};
  // const navigation = useNavigate() 
  const [user] = useState(""+loginVal.user_Id);
  const [activeChat, setActiveChat] = useState(""+opponentId);
  const [messages, setMessages] = useState([]);
  const [chatList, setChatList] = useState([]);


  // ---------------- SIGNALR ----------------
  useEffect(() => {

    const start = async () => {

      if (connection.state === "Disconnected") {

        await connection.start();

        await connection.invoke("Register", user);
      }

      // RECEIVE MESSAGE
      connection.on("ReceiveMessage", (msg) => {
        console.log('messae received');
        setMessages(prev => [...prev, msg]);
      });

      // // STATUS UPDATE
      // connection.on("MessageStatus", (msg) => {
      //   setMessages(prev =>
      //     prev.map(m => m.id === msg.id ? msg : m)
      //   );
      // });
    };

    start();

    return () => {
      connection.off("ReceiveMessage");
      connection.off("MessageStatus");
    };

  }, []);

  // ---------------- CHAT LIST ----------------
  useEffect(() => {

    // axios.get(`https://dev.indiametti.com/api/chat/users?user=${user}`)
    //   .then(res => setChatList(res.data));

      
    axios.get(`https://indiametti.com/api/chat/users?user=${user}`)
      .then(res => setChatList(res.data));

  }, []);

  useEffect(() => {
  const fetchMessages = async () => {
    try {
      // const res = await axios.get(
      //   `https://dev.indiametti.com/api/chat/messages?user1=${user}&user2=${activeChat}`
      // );

        const res = await axios.get(
        `https://indiametti.com/api/chat/messages?user1=${user}&user2=${activeChat}`
      );

      setMessages(res.data);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  fetchMessages();
}, [user, activeChat]);

  // ---------------- OPEN CHAT ----------------
  const openChat = async (otherUser) => {

    setActiveChat(otherUser);

    // const res = await axios.get(
    //    `https://dev.indiametti.com/api/chat/messages?user1=${user}&user2=${otherUser}`
    // );


    const res = await axios.get(
       `https://indiametti.com/api/chat/messages?user1=${user}&user2=${otherUser}`
    );


    setMessages(res.data);
  };

  return (

    <div className={`chat-container ${activeChat ? "chat-view-active" : ""}`} >

      {/* <ChatList
        chats={chatList}
        activeChat={activeChat}
        openChat={openChat}
      /> */}

      {activeChat ? (
        <ChatWindow
        activeChatName={opponentName}
          user={user}
          activeChat={activeChat}
          messages={messages}
          setMessages={setMessages}
          onBack={() => setActiveChat(null)}
        />
      ) : (
        <div className="no-chat-selected">
          <div className="welcome-screen">
            <div className="icon">💬</div>
            <h2>IndiaMetti Web</h2>
            <p>Select a contact to start chatting.</p>
          </div>
        </div>
      )}

    </div>
  );
}

export default ChatInit;